import * as types from '../mutation-types'
import axios from "axios";

// state
export const state = {
    all: []
};

// getters
export const getters = {
    all: state => state.all
};

// mutations
export const mutations = {
    [types.CREDIT_MANAGERS_ALL_SET] (state, data) {
        state.all = data;
    }
};

// actions
export const actions = {
    async fetch(context) {
        await axios.get('/api/credit_managers')
            .then(function (response) {
                context.commit(types.CREDIT_MANAGERS_ALL_SET, response.data)
            });
    }
};
